export function getRedirectUri(): string | undefined {
  return window.location.origin + window.location.pathname;
}
